<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" size="small" :rules="loginRules"
             class="login-form" auto-complete="on" label-position="left">
      <h3 class="title">小南瓜可视化平台saas版(V1.0)</h3>
      <el-form-item prop="username">
        <div class="formDiv">
          <div class="formLabel"> <i class="el-icon-user-solid"></i> </div>
          <input class="ipt" v-model="loginForm.username" placeholder="用户名"/>
        </div>
      </el-form-item>
      <el-form-item prop="password">
        <div class="formDiv">
          <div class="formLabel"> <i class="el-icon-lock"></i> </div>
          <input class="ipt"  v-model="loginForm.password" autocomplete="new-password"
                    :type="passwordType" placeholder="密码" @keyup.enter="handleLogin" />
          <span class="show-pwd" @click="showPwd">
              <i :class="passwordType === 'password' ? 'el-icon-view' : 'el-icon-more'" />
          </span>
        </div>
      </el-form-item>
      <el-row :gutter="12">
        <el-col :span="18">
          <el-form-item prop="username">
            <div class="formDiv">
              <div class="formLabel"> <i class="el-icon-info"></i> </div>
              <input class="ipt" v-model="loginForm.authCode" placeholder="验证码" @keyup.enter="handleLogin" />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
         <el-image :src="baseUrl+'/sysCode/getCodeImg?time='+time" @click="time = new Date().getTime()"/><!-- time刷新作用-->
        </el-col>
      </el-row>
      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">登 录</el-button>
    </el-form>
  </div>
</template>

<script>

import env from '/env'
import {login,applogin,getPwd} from '@/api/user'
import {setToken} from "@/utils/auth";

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      callback()
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error('密码非法'))
      } else {
        callback()
      }
    }
    return {
      loginForm: { username: 'yabushan',password: 'common',authCode:'' },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      baseUrl: env.baseUrl,
      time:''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
		  debugger;
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
  	const name =  "Admin-Token=";
  	const decodedCookie = decodeURIComponent(document.cookie);
  	const cookieArray = decodedCookie.split(';');
  	for (let i = 0; i < cookieArray.length; i++) {
  	    let cookie = cookieArray[i].trim();
		/* let Base64 = require('js-base64').Base64; */
		let loginParam = JSON.parse(JSON.stringify(this.loginForm));
  	    if (cookie.indexOf(name) === 0) {
  			const adminToken=cookie.substring(name.length, cookie.length);
			loginParam.adminToken=adminToken;
			//通过token获取到密钥
			getPwd(adminToken).then(res => {
				if(res.code ==1 && res.msg =='success'){
					this.loginForm.password=res.data.password;
					this.loginForm.username=res.data.username;
					
					loginParam.password=res.data.password;
					loginParam.username=res.data.username;
					console.log("loginParam>>>"+loginParam.password);
					/* loginParam.password = Base64.encode(loginParam.password) */
					login(loginParam).then(res => {
					  localStorage.setItem('userinfo', JSON.stringify(res.data))
					  console.log(res.data.token)
					  setToken(res.data.token)
					  this.$router.push({ path: this.redirect || '/' })
					  this.loading = false
					}).catch(error => {
					  console.log(error)
					  this.time = new Date().getTime()
					  this.loading = false
					})
					
				}
			}
			).catch(error => {
			  console.log(error)
			  this.time = new Date().getTime()
			  this.loading = false
			})

			
  	    }
  	}
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
	appLogin() {//一键登录
	let ca = document.cookie.split(';');
	let loginParam = JSON.parse(JSON.stringify(this.loginForm))
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		if(c.indexOf("qx_username")!=-1){
			let usernames = ca[i].split('=');
			loginParam.username=usernames[1];
			loginParam.password="ngs_sxf_"+usernames[1];
			let Base64 = require('js-base64').Base64
			loginParam.password = Base64.encode(loginParam.password)
			break
		}
	}
     applogin(loginParam).then(res => {
		 
       localStorage.setItem('userinfo', JSON.stringify(res.data))
       setToken(res.data.token)
       this.$router.push({ path: this.redirect || '/' })
       this.loading = false
     }).catch(error => {
       console.log(error)
       this.time = new Date().getTime()
       this.loading = false
     })	  
	},
	
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          let Base64 = require('js-base64').Base64
          this.loading = true;
          let loginParam = JSON.parse(JSON.stringify(this.loginForm))
          loginParam.password = Base64.encode(loginParam.password)

          login(loginParam).then(res => {
            localStorage.setItem('userinfo', JSON.stringify(res.data))
            setToken(res.data.token)
            this.$router.push({ path: this.redirect || '/' })
            this.loading = false
          }).catch(error => {
            console.log(error)
            this.time = new Date().getTime()
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
	getCookie(cookieName) {
	    const name = cookieName + "=";
	    const decodedCookie = decodeURIComponent(document.cookie);
	    const cookieArray = decodedCookie.split(';');
	    
	    for (let i = 0; i < cookieArray.length; i++) {
	        let cookie = cookieArray[i].trim();
	        if (cookie.indexOf(name) === 0) {
	            return cookie.substring(name.length, cookie.length);
	        }
	    }
	    
	    return null;
	}
  }
}
</script>


<style scoped>
.login-container { position: relative; min-height: 100%; width: 100%; background-image: url(../../assets/login-background.png);background-repeat: no-repeat;background-size: 100% 100%; overflow: hidden;}
.login-form { position: absolute; width: 460px;height: 350px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  padding: 0 35px 0 35px; margin:auto; overflow: hidden;border-radius: 6px;box-shadow: 0 0 6px 0px #eee;}
.title { font-size: 26px; color: #666; margin: 0;padding: 20px 0; text-align: center; font-weight: bold;}
.show-pwd { position: absolute; right: 10px; top: 5px; font-size: 16px; color: #889aa4;
  cursor: pointer; user-select: none;}
.formDiv{background-color: #fff;border: 1px solid #ddd;border-radius: 6px;height: 46px;}
.formLabel{display: inline-block;width: 30px;font-size: 18px;color: #889aac;text-align: right}
.ipt{ display: inline-block;width: 80%;height: 100%;font-size: 15px; color: #999;padding-left: 10px;border: none;
  background: #0000;outline:none}
.ipt::-ms-reveal{ display:none}
</style>
